<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>关卡数值配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:popUp:addLevel']" size="mini" type="primary" @click="dialogVisible = true">添加</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs tab-position="left" style="height: 100%;">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :label="tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="首次登录" name="first">
                <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0 0 20px;">
                  <el-form-item label="等级">
                    <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>minLevelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>minLevelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>

                  <el-form-item label="积分">
                    <el-input v-model.number="tabItem.min_score" style="width: 100px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_score" style="width: 100px;" placeholder="最大值" />
                  </el-form-item>
                  <div v-if="formData.hasOwnProperty(tabItem.min_level+ '-' + tabItem.max_level)">
                    <el-row v-for="(item,i) in formData[tabItem.min_level+ '-' + tabItem.max_level].firstLogin.data" :key="i">
                      <el-form-item label="优先级">
                        <el-input v-model.number="item.level" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item label="分组">
                        <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                      </el-form-item>
                      <el-form-item label="弹窗类型">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in popType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否必现">
                        <el-select v-model="item.is_appear" placeholder="请选择">
                          <el-option
                            v-for="iitem in appearType"
                            :key="iitem.value"
                            :label="iitem.label"
                            :value="iitem.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="概率">
                        <el-input v-model.number="item.is_require" :disabled="item.is_appear === 1 ? true : false" style="width: 100px;" placeholder="概率" />
                      </el-form-item>
                      <el-form-item>
                        <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('firstLogin', tabItem.min_level+ '-' + tabItem.max_level, i,item.id)">删除</el-button>
                      </el-form-item>
                    </el-row>
                  </div>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="addEvent('firstLogin', tabItem.min_level+ '-' + tabItem.max_level)">+</el-button>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('firstLogin')">保存</el-button>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="当日非首次" name="second">
                <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
                  <el-form-item label="等级">
                    <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>minLevelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>minLevelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>

                  <el-form-item label="积分">
                    <el-input v-model.number="tabItem.min_score" style="width: 100px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_score" style="width: 100px;" placeholder="最大值" />
                  </el-form-item>
                  <div v-if="formData.hasOwnProperty(tabItem.min_level+ '-' + tabItem.max_level)">
                    <el-row v-for="(item,i) in formData[tabItem.min_level+ '-' + tabItem.max_level].noFirstLogin.data" :key="i">
                      <el-form-item label="优先级">
                        <el-input v-model.number="item.level" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item label="分组">
                        <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                      </el-form-item>
                      <el-form-item label="弹窗类型">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in popType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否必现">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in appearType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="概率">
                        <el-input v-model.number="item.is_require" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item>
                        <el-button v-permisaction="['config:config:popUp:add:add']" type="danger" @click="delEvent('noFirstLogin', tabItem.min_level+ '-' + tabItem.max_level, i,item.id)">删除</el-button>
                      </el-form-item>
                    </el-row>
                  </div>
                  <el-button v-permisaction="['config:config:popUp:add:add']" type="primary" @click="addEvent('noFirstLogin', tabItem.min_level+ '-' + tabItem.max_level)">+</el-button>
                  <el-button v-permisaction="['config:config:popUp:add:add']" type="primary" @click="onSubmit('noFirstLogin')">保存</el-button>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="骰子破产" name="third">
                <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
                  <el-form-item label="等级">
                    <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>minLevelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>minLevelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>

                  <el-form-item label="积分">
                    <el-input v-model.number="tabItem.min_score" style="width: 100px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_score" style="width: 100px;" placeholder="最大值" />
                  </el-form-item>
                  <div v-if="formData.hasOwnProperty(tabItem.min_level+ '-' + tabItem.max_level)">
                    <el-row v-for="(item,i) in formData[tabItem.min_level+ '-' + tabItem.max_level].sieveBankruptcy.data" :key="i">
                      <el-form-item label="优先级">
                        <el-input v-model.number="item.level" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item label="分组">
                        <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                      </el-form-item>
                      <el-form-item label="弹窗类型">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in popType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否必现">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in appearType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="概率">
                        <el-input v-model.number="item.is_require" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item>
                        <el-button v-permisaction="['config:popUp:del']" type="danger" @click="delEvent('sieveBankruptcy', tabItem.min_level+ '-' + tabItem.max_level, i,item.id)">删除</el-button>
                      </el-form-item>
                    </el-row>
                  </div>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="addEvent('sieveBankruptcy', tabItem.min_level+ '-' + tabItem.max_level)">+</el-button>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('sieveBankruptcy')">保存</el-button>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="钞票破产" name="fourth">
                <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
                  <el-form-item label="等级">
                    <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>minLevelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>minLevelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>

                  <el-form-item label="积分">
                    <el-input v-model.number="tabItem.min_score" style="width: 100px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_score" style="width: 100px;" placeholder="最大值" />
                  </el-form-item>
                  <div v-if="formData.hasOwnProperty(tabItem.min_level+ '-' + tabItem.max_level)">
                    <el-row v-for="(item,i) in formData[tabItem.min_level+ '-' + tabItem.max_level].bankruptcyOfBanknotes.data" :key="i">
                      <el-form-item label="优先级">
                        <el-input v-model.number="item.level" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item label="分组">
                        <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                      </el-form-item>
                      <el-form-item label="弹窗类型">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in popType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否必现">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in appearType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="概率">
                        <el-input v-model.number="item.is_require" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item>
                        <el-button v-permisaction="['config:popUp:del']" type="danger" @click="delEvent('bankruptcyOfBanknotes', tabItem.min_level+ '-' + tabItem.max_level, i,item.id)">删除</el-button>
                      </el-form-item>
                    </el-row>
                  </div>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="addEvent('bankruptcyOfBanknotes', tabItem.min_level+ '-' + tabItem.max_level)">+</el-button>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfBanknotes')">保存</el-button>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="玩法破产" name="fiftieth">
                <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
                  <el-form-item label="等级">
                    <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>minLevelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>minLevelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)" />
                  </el-form-item>

                  <el-form-item label="积分">
                    <el-input v-model.number="tabItem.min_score" style="width: 100px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="-">
                    <el-input v-model.number="tabItem.max_score" style="width: 100px;" placeholder="最大值" />
                  </el-form-item>
                  <div v-if="formData.hasOwnProperty(tabItem.min_level+ '-' + tabItem.max_level)">
                    <el-row v-for="(item,i) in formData[tabItem.min_level+ '-' + tabItem.max_level].bankruptcyOfGameplay.data" :key="i">
                      <el-form-item label="优先级">
                        <el-input v-model.number="item.level" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item label="分组">
                        <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                      </el-form-item>
                      <el-form-item label="弹窗类型">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in popType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否必现">
                        <el-select v-model="item.pop_type" placeholder="请选择">
                          <el-option
                            v-for="item in appearType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="概率">
                        <el-input v-model.number="item.is_require" style="width: 100px;" placeholder="优先级" />
                      </el-form-item>
                      <el-form-item>
                        <el-button v-permisaction="['config:popUp:del']" type="danger" @click="delEvent('bankruptcyOfGameplay', tabItem.min_level+ '-' + tabItem.max_level, i, item.id)">删除</el-button>
                      </el-form-item>
                    </el-row>
                  </div>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="addEvent('bankruptcyOfGameplay', tabItem.min_level+ '-' + tabItem.max_level)">+</el-button>
                  <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { deletePopUpCfg, getPopUpCfg, updatePopUpCfg } from '@/api/config/pop-up-cfg'
export default {
  name: 'PopUp',
  data() {
    return {
      tabPane: [
        { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      popType: [
        { 'label': '推送更新', value: 1 },
        { 'label': '签到', value: 2 }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      activeName: 'first',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updatePopUpCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getPopUpCfg().then(res => {
        if (res.code === 200) {
          this.tabPane = []
          for (const d in res.data) {
            const val = res.data[d]
            const [min_level, max_level] = d.split('-')
            this.tabPane.push({
              'label': d,
              'min_level': min_level,
              'max_level': max_level,
              'bak_min_level': min_level,
              'bak_max_level': max_level,
              'min_score': 0,
              'max_score': 0,
              add: true
            })
            console.log(val)
            this.$set(this.formData, d, val)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    minLevelChange(newVal, isMin, bakMin, bakMax) {
      const oldLevelName = bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      console.log(this.formData)
      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
          this.formData[newLevelName].firstLogin.min_level = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
          this.formData[newLevelName].firstLogin.max_level = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }

      console.log(fileIndex)
    },
    addEvent(eventName, levelName) {
      console.log(eventName, levelName)
      console.log(this.formData[levelName])
      this.formData[levelName][eventName].data.push({
        'id': 0,
        'level': 1,
        'group': 0,
        'pop_type': 0,
        'is_appear': 0,
        'is_require': 0
      })

      // Vue.set(this.formData[levelName][eventName].data, this.formData[levelName][eventName].data.length, {
      //   'level': 1,
      //   'group': 0,
      //   'pop_type': 0,
      //   'is_appear': 0,
      //   'is_require': 0
      // })

      console.log(this.formData[levelName][eventName])
    },
    delEvent(eventName, levelName, index, id) {
      if (id > 0) {
        deletePopUpCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      } else {
        this.formData[levelName][eventName].data = this.formData[levelName][eventName].data.filter((item, key) => {
          return index !== key
        })
      }
    },
    addLevel() {
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        'min_score': 0,
        'max_score': 0,
        add: true
      })
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level

      this.$set(this.formData, levelName, {
        'firstLogin': {
          'min_level': this.levelFormData.min_level,
          'max_level': this.levelFormData.max_level,
          'min_score': 0,
          'max_score': 0,
          'data': [{
            'id': 0,
            'level': 1,
            'group': 0,
            'pop_type': 0,
            'is_appear': 0,
            'is_require': 0
          }]
        },
        'noFirstLogin': {
          'min_level': this.levelFormData.min_level,
          'max_level': this.levelFormData.max_level,
          'bak_min_level': 0,
          'bak_max_level': 0,
          'min_score': 0,
          'max_score': 0,
          'data': [{
            'id': 0,
            'level': 1,
            'group': 0,
            'pop_type': 0,
            'is_appear': 0,
            'is_require': 0
          }]
        },
        'sieveBankruptcy': {
          'min_level': this.levelFormData.min_level,
          'max_level': this.levelFormData.max_level,
          'bak_min_level': 0,
          'bak_max_level': 0,
          'min_score': 0,
          'max_score': 0,
          'data': [{
            'id': 0,
            'level': 1,
            'group': 0,
            'pop_type': 0,
            'is_appear': 0,
            'is_require': 0
          }]
        },
        'bankruptcyOfBanknotes': {
          'min_level': this.levelFormData.min_level,
          'max_level': this.levelFormData.max_level,
          'bak_min_level': 0,
          'bak_max_level': 0,
          'min_score': 0,
          'max_score': 0,
          'data': [{
            'id': 0,
            'level': 1,
            'group': 0,
            'pop_type': 0,
            'is_appear': 0,
            'is_require': 0
          }]
        },
        'bankruptcyOfGameplay': {
          'min_level': this.levelFormData.min_level,
          'max_level': this.levelFormData.max_level,
          'bak_min_level': 0,
          'bak_max_level': 0,
          'min_score': 0,
          'max_score': 0,
          'data': [{
            'id': 0,
            'level': 1,
            'group': 0,
            'pop_type': 0,
            'is_appear': 0,
            'is_require': 0
          }]
        }
      })
      console.log(this.formData)
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'iconId': 0,
        'physical_reward': 0,
        'conis_reward': 0
      })
    },
    del(key, id) {
      this.formData = this.formData.filter((item, index) => {
        return index !== key
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped>
</style>
